import { useContext, useEffect, useState } from 'react'
import { Alert, CircularProgress } from '@mui/material'
import { Link } from 'react-router-dom'

import { AppContext } from '/providers/app-context'
import { quoteCredits } from '/providers/passes-api'

const CreditQuote = ({ templateId, eventType, passCount, mode = 'live', onChange }) => {
  const { apiSource, apiKey, client } = useContext(AppContext)
  const [quote, setQuote] = useState(null)

  useEffect(() => {
    let active = true
    if (!templateId || !passCount) return undefined
    setQuote(null)
    quoteCredits({ apiSource, apiKey, apiMode: mode, templateId, eventType, numPasses: passCount })
      .then(result => {
        if (!active) return
        setQuote(result)
        onChange?.(result)
      })
    return () => { active = false }
  }, [apiSource, apiKey, mode, templateId, eventType, passCount, onChange])

  if (!quote) return <Alert severity='info' icon={<CircularProgress size={16} />}>Calculating credit cost…</Alert>
  if (!quote.ok) return <Alert severity='warning'>Unable to calculate the credit cost. Please try again.</Alert>
  const creditsRequired = Number(quote.credits_required ?? 0)
  const creditsAvailable = Number(quote.credits_available ?? 0)

  if (client?.billing_mode === 'postpay') return <Alert severity='info'>This action will use {creditsRequired.toLocaleString()} credits. Your account is billed monthly.</Alert>
  if (!quote.sufficient) return <Alert severity='warning'>
    This action requires {creditsRequired.toLocaleString()} credits; {creditsAvailable.toLocaleString()} are available. <Link to='/billing/buy-credits' className='link'>Purchase more credits</Link> to continue.
  </Alert>
  return <Alert severity='info'>This action will use {creditsRequired.toLocaleString()} credits. {creditsAvailable.toLocaleString()} credits are available.</Alert>
}

export default CreditQuote
